<template>
  <div>
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">교재 코드</label>

          <vs-select class="mb-4 w-full" v-model="bookInfo" name="item-book-code" v-on:change="onBookchanged">
            <vs-select-item :key="item.bookCode" :value="item" :text="item.bookCode" v-for="item in bookCodeList" />
          </vs-select>

        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">UNIT</label>

          <vs-select class="mb-4 w-full" v-model="unitCode" name="item-unit-code" v-on:change="onUnitCodechanged">
            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in unitList" />
          </vs-select>

        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">STEP</label>

          <vs-select class="mb-4 w-full" v-model="stepCode" name="item-step-code" v-on:change="onStepCodechanged">
            <vs-select-item :key="item.value" :value="item.codeKey" :text="item.codeValue" v-for="item in stepList" />
          </vs-select>

        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">MENU</label>

          <vs-select class="mb-4 w-full" v-model="menuCode" name="item-menu-code" v-on:change="onMenuCodechanged">
            <vs-select-item :key="item.value" :value="item.codeKey" :text="item.codeValue" v-for="item in menuList" />
          </vs-select>

        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>

import { fetchData } from '@/api/module'

export default {
  components: {
  },
  data () {
    return {
      bookInfo: null,
      menuCode: '',
      //bookCode: '',
      unitCode: '',
      stepCode: '',
      bookCodeList: [],
      unitList: [],
      menuList: [],
      stepList: []
    }
  },
  watch: {
  },
  methods: {
    onBookchanged () {
      this.$emit('onBookCodeChanged', this.bookInfo)
      this.stepCode = ''
      const params = {
        codeKey: this.bookInfo.courseCode
      }
      this.loadStep(params)
    },
    onUnitCodechanged () {
      this.$emit('onUnitChanged', this.unitCode)
    },
    onStepCodechanged () {
      this.$emit('onStepCodeChanged', this.stepCode)
      this.menuCode = ''
      
      if (this.stepCode.length === 0) return

      const params = {
        codeKey: this.stepCode
      }
      this.loadMenu(params)
    }, 
    onMenuCodechanged () {
      this.$emit('onMenuChanged', this.menuCode)
    },
    async loadStep (params) { 
      this.$vs.loading()
      try {
        const { data } = await fetchData('code/step', params)
        this.stepList = data.list 
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()    
    },
    async loadMenu (params) { 
      this.$vs.loading()
      try {
        const { data } = await fetchData('code/step/menu', params)
        this.menuList = data.list 
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()    
    }
  },
  async created () {

    try { 
      const { data } = await fetchData('/book/search')
      this.bookCodeList = data.list
    } catch (error) {

      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
    
    this.unitList.push({label: 'U01', value: 'U01'})   
    this.unitList.push({label: 'U02', value: 'U02'})   
    this.unitList.push({label: 'U03', value: 'U03'})   
    this.unitList.push({label: 'U04', value: 'U04'})   
    this.unitList.push({label: 'U05', value: 'U05'})   
    this.unitList.push({label: 'U06', value: 'U06'})

    this.unitList.push({label: 'U07', value: 'U07'})
    this.unitList.push({label: 'U08', value: 'U08'})
    this.unitList.push({label: 'U09', value: 'U09'})
    this.unitList.push({label: 'U10', value: 'U10'})
    this.unitList.push({label: 'U11', value: 'U11'})
    this.unitList.push({label: 'U12', value: 'U12'})
    this.unitList.push({label: 'U13', value: 'U13'})
    this.unitList.push({label: 'U14', value: 'U14'})
    this.unitList.push({label: 'U15', value: 'U15'})
    this.unitList.push({label: 'U16', value: 'U16'})
    this.unitList.push({label: 'U17', value: 'U17'})
    this.unitList.push({label: 'U18', value: 'U18'})
    this.unitList.push({label: 'U19', value: 'U19'})
    this.unitList.push({label: 'U20', value: 'U20'})
    this.unitList.push({label: 'U21', value: 'U21'})
    this.unitList.push({label: 'U22', value: 'U22'})
    this.unitList.push({label: 'U23', value: 'U23'})
    this.unitList.push({label: 'U24', value: 'U24'})
    this.unitList.push({label: 'U25', value: 'U25'})
    this.unitList.push({label: 'U26', value: 'U26'})
    this.unitList.push({label: 'U27', value: 'U27'})
    this.unitList.push({label: 'U28', value: 'U28'})
    this.unitList.push({label: 'U29', value: 'U29'})
    this.unitList.push({label: 'U30', value: 'U30'})
    this.unitList.push({label: 'U31', value: 'U31'})
    this.unitList.push({label: 'U32', value: 'U32'})
    this.unitList.push({label: 'U33', value: 'U33'})
    this.unitList.push({label: 'U34', value: 'U34'})
    this.unitList.push({label: 'U35', value: 'U35'})
    this.unitList.push({label: 'U36', value: 'U36'})
    this.unitList.push({label: 'U37', value: 'U37'})
    this.unitList.push({label: 'U38', value: 'U38'})
    this.unitList.push({label: 'U39', value: 'U39'})
    this.unitList.push({label: 'U40', value: 'U40'})
    this.unitList.push({label: 'U41', value: 'U41'})
    this.unitList.push({label: 'U42', value: 'U42'})
    this.unitList.push({label: 'U43', value: 'U43'})
    this.unitList.push({label: 'U44', value: 'U44'})
    this.unitList.push({label: 'U45', value: 'U45'})
    this.unitList.push({label: 'U46', value: 'U46'})
    this.unitList.push({label: 'U47', value: 'U47'})
    this.unitList.push({label: 'U48', value: 'U48'})
    this.unitList.push({label: 'U49', value: 'U49'})
    this.unitList.push({label: 'U50', value: 'U50'})

    // this.stepList.push({label: 'SP-Dictation', value: 'SP05'})
    // this.stepList.push({label: 'SP-Let\'s Drill', value: 'SP07'})
    // this.stepList.push({label: 'SP-Listen Up', value: 'SP09'})
    // this.stepList.push({label: 'SP-Listening', value: 'SP01'})
    // this.stepList.push({label: 'SP-Phonics', value: 'SP04'})
    // this.stepList.push({label: 'SP-Read All About', value: 'SP11'})
    // this.stepList.push({label: 'SP-Reading', value: 'SP03'})
    // this.stepList.push({label: 'SP-Speak Up', value: 'SP08'})
    // this.stepList.push({label: 'SP-Speaking', value: 'SP06'})
    // this.stepList.push({label: 'SP-Vocabulary', value: 'SP02'})
    // this.stepList.push({label: 'SP-Writing', value: 'SP10'})

    // this.stepList.push({label: 'RD-Dictation', value: 'RD03'})
    // this.stepList.push({label: 'RD-Listening', value: 'RD01'})
    // this.stepList.push({label: 'RD-Reading', value: 'RD04'})
    // this.stepList.push({label: 'RD-Vocabulary', value: 'RD02'})
    // this.stepList.push({label: 'RD-Writing', value: 'RD05'})

    // this.stepList.push({label: 'PH-Phonics', value: 'PH01'})

    // this.stepList.push({label: 'VC-Vocabulary', value: 'VC01'})

    // this.stepList.push({label: 'GR-Vocabulary', value: 'GR01'})

    // this.stepList.push({label: 'WR-Basic Writing', value: 'WR01'})

    // this.menuList.push({label: '(P010) Listening Phonics', value: 'P010'})
    // this.menuList.push({label: '(P020) Speaking Phonics', value: 'P020'})
    // this.menuList.push({label: '(P030) Matching Phonics', value: 'P030'})
    // this.menuList.push({label: '(P040) Writing Phonics', value: 'P040'})

    // this.menuList.push({label: '(L010) Listening Sound', value: 'L010'})
    // this.menuList.push({label: '(L020) Listening with Pictures', value: 'L020'})
    // this.menuList.push({label: '(L030) Listening With Subtitles', value: 'L030'})
    // this.menuList.push({label: '(L040) Listening Korean', value: 'L040'})
    // this.menuList.push({label: '(L070) Listen and Fill In', value: 'L070'})
    // this.menuList.push({label: '(L080) Sentence Dictation Type1', value: 'L080'})
    // this.menuList.push({label: '(L081) Sentence Dictation Type2', value: 'L081'})
 
    // this.menuList.push({label: '(V010) Listening Words', value: 'V010'})
    // this.menuList.push({label: '(V020) Speaking Words', value: 'V020'})
    // this.menuList.push({label: '(V030) Words Dictation 1', value: 'V030'})
    // this.menuList.push({label: '(V031) Words Dictation 2', value: 'V031'})
    // this.menuList.push({label: '(V032) Words Dictation 3', value: 'V032'})
    // this.menuList.push({label: '(V040) Writing Words', value: 'V040'})
    // this.menuList.push({label: '(V050) Checking Words', value: 'V050'})
    // this.menuList.push({label: '(V070) Memorizing Words 1', value: 'V070'})
    // this.menuList.push({label: '(V071) Memorizing Words 2', value: 'V071'})
    // //this.menuList.push({label: '(V080) Listening Words(L3~L7)', value: 'V080'})

    // this.menuList.push({label: '(R020) Intonation Reading', value: 'R020'})
    // this.menuList.push({label: '(R030) Speed Reading', value: 'R030'})
    // this.menuList.push({label: '(R040) Translating', value: 'R040'}) //Reading and Translating
    // this.menuList.push({label: '(R050) Reading and Speaking', value: 'R050'})
    // this.menuList.push({label: '(R060) Shadow Reading', value: 'R060'})

    // this.menuList.push({label: '(S010) Sentence Speaking', value: 'S010'})
    // this.menuList.push({label: '(S020) Role Play', value: 'S020'})
    // this.menuList.push({label: '(S030) Speak Straight', value: 'S030'})
    // this.menuList.push({label: '(S050) Pattern Practice', value: 'S050'})
    // this.menuList.push({label: '(S060) Pattern Extension', value: 'S060'})

    // this.menuList.push({label: '(W010) Matching Sentences', value: 'W010'})
    // this.menuList.push({label: '(W020) Writing Blank Type 1', value: 'W020'})
    // this.menuList.push({label: '(W021) Writing Blank Type 2', value: 'W021'})
    // this.menuList.push({label: '(W022) Writing Blank Type 3', value: 'W022'})
    // this.menuList.push({label: '(W023) Writing Blank Type 4', value: 'W023'})
    // //this.menuList.push({label: '(W030) Writing Composition', value: 'W030'})

    // this.menuList.push({label: '(P050) Listening Phonics1', value: 'P050'})
    // this.menuList.push({label: '(P060) Listening Phonics2', value: 'P060'})
    // this.menuList.push({label: '(P070) Speaking Phonics1', value: 'P070'})
    // this.menuList.push({label: '(P080) Speaking Phonics2', value: 'P080'})
    // this.menuList.push({label: '(P090) Matching Phonics1', value: 'P090'})
    // this.menuList.push({label: '(P100) Matching Phonics2', value: 'P100'})
    // this.menuList.push({label: '(P110) Writing Phonics1', value: 'P110'})
    // this.menuList.push({label: '(P120) Writing Phonics2', value: 'P120'})
  }
}
</script>
